enum SourceClient {
    OCTANE_EXTENSION = 'octane_extension',
    QUICK_APP = 'quick_app',
    DIRECT_TO_CONSUMER_PREAPPROVAL = 'direct_to_consumer_preapproval',
}

export default SourceClient
